module.exports = __webpack_public_path__ + "img/45.9c06c4d4.jpg";